// HELPERS
import {createClassName} from "@helpers/utils";
import React from "react";

// CLASSES

// COMPONENTS
import ContentBox from "@components/ContentBox/ContentBox";
import DefaultFields from "../../../components/DefaultFields/DefaultFields";

// OTHER
import fulfillment from "./GoalsAndPurpose.fulfillment";
import OptionsList from "../../../components/OptionsList/OptionsList.jsx";
import TextView from "../../../../../components/TextView/TextView.jsx";
import Select from "../../../../../components/Select/Select.jsx";

export default class GoalsAndPurpose extends React.PureComponent
{
	state = _getInitialState.call(this);
	fields = _getFields.call(this);

	horizonOptions = [
		{
			value: "Mindre än 6 år",
			label: "Mindre än 6 år"
		},
		{
			value: "Mer än 6 år",
			label: "Mer än 6 år"
		},
		{
			value: "Vet ej",
			label: "Vet ej"
		}
	];

	isFulfilled(state)
	{
		return fulfillment(state, this.state);
	}

	setCustomerState(customerState, callbackFn)
	{
		customerState = {...this.state.customerState, ...customerState};
		this.setState({
			customerState,
			isFulfilled: this.isFulfilled({customerState})
		}, () =>
		{
			this.props.setAppState({viewFulfilled: this.state.isFulfilled});
			if (callbackFn)
			{
				callbackFn();
			}
		});
	}

	componentDidMount()
	{
		const {props} = this;
		const {setAppState} = props;

		// Set navigation events
		setAppState({
			viewFulfilled: this.isFulfilled(),
			showValidationWarning: false,
			navigationButtons: {
				sharing: {},
				back: {},
				next: {
					onClick: () =>
					{
						if (this.state.isFulfilled === true)
						{
							return;
						}

						this.setState({hasFormValidationErrors: true});
						return setAppState({
							showValidationWarning: true
						});
					}
				}
			}
		});
	}

	render()
	{
		const {customerState, readOnly} = this.state;
		const hasFormValidationErrors = !this.state.isFulfilled && this.state.hasFormValidationErrors;
		const classes = createClassName("Cob-view Cob-view2", {});

		return (
			<div className={classes}>
				<DefaultFields fields={this.fields}/>

				<ContentBox>
					<h2>Målsättningar och syften</h2>

					<div className="Cob-view2-fields">

						<p className="text">
							<strong>OBS!</strong> Detta är ej att anse som rådgivning av en lösning utan endast för behovsanalys
							och internt bruk. Om kunden svarar på ett sätt som tyder på att en lösning bör rådges
							skall detta göras först efter lämplighetsbedömning.
						</p>

						<OptionsList
							style={{marginBottom: "0"}}
							type="radio"
							description={"Givet de förutsättningar kunden angett, är kunden nöjd med den avkastning den uppnått?"}
							name="radio_customer_satisfied"
							value={customerState.radio_customer_satisfied}
							options={[
								{
									label: "Nej",
									value: "no",
									checked: customerState.radio_customer_satisfied === "no"
								},
								{
									label: "Ja",
									value: "yes",
									checked: customerState.radio_customer_satisfied === "yes"
								},
								{
									label: "Varken eller",
									value: "neither",
									checked: customerState.radio_customer_satisfied === "neither"
								}
							]}
							onChange={(checked, radio_customer_satisfied) => this.setCustomerState({radio_customer_satisfied})}
							validation={(value) => ((value && value.length > 0) || false)}
							readOnly={readOnly}
						/>

						<p className={"field-label"}>
							Om det ger möjlighet till en betydligt högre avkastning, vilken
							placeringshorisont kan kunden tänka sig?
						</p>
						<Select
							name="customer_extension_horizon_possible"
							label={"Välj"}
							selectedIndex={this.horizonOptions.map(c => c.value).indexOf(customerState.customer_extension_horizon_possible)}
							options={this.horizonOptions}
							onChange={(option) =>
							{
								this.setCustomerState({customer_extension_horizon_possible: option.value});
							}}
							readOnly={readOnly}
						/>

						<OptionsList
							style={{marginBottom: "0", marginTop: "15px"}}
							type="radio"
							description={"Är det helt otänkbart för er att förlänga er placeringshorisont för möjligheten att uppnå en betydligt högre avkastningsmöjlighet?"}
							name="radio_customer_extension_possible"
							value={customerState.radio_customer_extension_possible}
							options={[
								{
									label: "Nej",
									value: "no",
									checked: customerState.radio_customer_extension_possible === "no"
								},
								{
									label: "Ja",
									value: "yes",
									checked: customerState.radio_customer_extension_possible === "yes"
								}
							]}
							onChange={(checked, radio_customer_extension_possible) => this.setCustomerState({radio_customer_extension_possible})}
							validation={(value) => ((value && value.length > 0) || false)}
							readOnly={readOnly}
						/>

						<p className={"field-label"}>
							Beskriv vad som diskuterats gällande Investmentbolaget Camp B
						</p>
						<TextView
							name="customer_campb_discussion"
							label={`Fritext (${1800 - customerState.customer_campb_discussion.length} tecken kvar)`}
							value={customerState.customer_campb_discussion}
							maxLength={1800}
							validation={value => value.length > 0}
							resize="vertical"
							onChange={({target}) => this.setCustomerState({customer_campb_discussion: target.value})}
							fullWidth
							minHeight={250}
							readOnly={readOnly}
						/>

						<OptionsList
							style={{marginBottom: "0", marginTop: "15px"}}
							type="radio"
							description={"Är investmentbolaget en potentiell lösning för kunden?"}
							name="radio_customer_campb_possible"
							value={customerState.radio_customer_campb_possible}
							options={[
								{
									label: "Nej",
									value: "no",
									checked: customerState.radio_customer_campb_possible === "no"
								},
								{
									label: "Ja",
									value: "yes",
									checked: customerState.radio_customer_campb_possible === "yes"
								}
							]}
							onChange={(checked, radio_customer_campb_possible) => this.setCustomerState({radio_customer_campb_possible})}
							validation={(value) => ((value && value.length > 0) || false)}
							readOnly={readOnly}
						/>
					</div>
				</ContentBox>
			</div>
		);
	}
}

// PRIVATE FUNCTIONS
function _getInitialState()
{
	const {customer, viewNo, hasFormValidationErrors, readOnly} = this.props;
	const seenViews = JSON.parse(localStorage.getItem(`SEEN_VIEWS_${btoa(customer.caseId)}`)) || [];
	const hasBeenSeen = (seenViews.includes(viewNo));

	// if it hasn't been seen add the view to local storage for the specific case
	if (customer.caseId && !hasBeenSeen)
	{
		localStorage.setItem(`SEEN_VIEWS_${btoa(customer.caseId)}`, JSON.stringify([...seenViews, viewNo]));
	}

	let newState = getViewInitialStateForCustomer(customer);
	newState.isFulfilled = this.isFulfilled(newState);
	newState.hasFormValidationErrors = hasBeenSeen || hasFormValidationErrors;
	newState.readOnly = readOnly;
	return newState;
}

export function getViewInitialStateForCustomer(customer)
{
	return {
		isFulfilled: false,
		isLoading: true,
		lookupNotFound: false,
		fraudFlag: false,
		errorMessage: null,
		customerState: {
			radio_customer_satisfied: customer.getData("radio_customer_satisfied", ""),
			customer_extension_horizon_possible: customer.getData("customer_extension_horizon_possible", ""),
			radio_customer_extension_possible: customer.getData("radio_customer_extension_possible", ""),
			customer_campb_discussion: customer.getData("customer_campb_discussion", ""),
			radio_customer_campb_possible: customer.getData("radio_customer_campb_possible", ""),
		}
	};
}

function _getFields()
{
	return [
		"radio_customer_satisfied",
		"customer_extension_horizon_possible",
		"radio_customer_extension_possible",
		"customer_campb_discussion",
		"radio_customer_campb_possible",
	];
}